module.exports = __webpack_public_path__ + "img/wanyuan0.a30120ad.png";